import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import type { PatientSummary, MedicalHistory } from '@/types/visit'

function computeAge(dateOfBirth: string): number {
  // Append T00:00:00 for date-only strings to avoid UTC timezone shift
  const normalized = dateOfBirth.includes('T') ? dateOfBirth : `${dateOfBirth}T00:00:00`
  const dob = new Date(normalized)
  const today = new Date()
  let age = today.getFullYear() - dob.getFullYear()
  const monthDiff = today.getMonth() - dob.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--
  }
  return age
}

function formatSexAtBirth(sex: string): string {
  switch (sex) {
    case 'male': return 'Male'
    case 'female': return 'Female'
    case 'intersex': return 'Intersex'
    case 'prefer_not_to_say': return 'Not disclosed'
    default: return sex
  }
}

interface PatientHeaderProps {
  patient: PatientSummary
  medicalHistory: MedicalHistory | null
}

export default function PatientHeader({ patient, medicalHistory }: PatientHeaderProps) {
  const navigate = useNavigate()

  return (
    <div className="flex items-center gap-4 rounded-lg border bg-white px-6 py-4">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate('/visits')}
        className="gap-1"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </Button>
      <div className="flex items-baseline gap-3">
        <h1 className="text-xl font-semibold text-slate-900">
          {patient.first_name} {patient.last_name}
        </h1>
        {medicalHistory && (
          <span className="text-sm text-slate-500">
            {computeAge(medicalHistory.date_of_birth)} y/o {formatSexAtBirth(medicalHistory.sex_at_birth)}
          </span>
        )}
      </div>
    </div>
  )
}
